// import library
import { useTranslation } from "react-i18next";
// import component
import Layout from "../../layouts/Layout";

const Notification = () => {
    // variables
    const { t } = useTranslation();
    
    return (
        <Layout>
            <div className="space-y-4">
                {/* first box */}
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="sm:text-2xl font-semibold capitalize">{ t('notifications') }</h1>
                        <p className="text-light-400 text-xs sm:text-sm capitalize">{ t('profile') } / { t('notifications') }</p>
                    </div>
                </div>
                <div className="flex flex-col justify-center items-center">
                    <div className="p-2 sm:p-4 bg-white border border-white rounded-lg text-center w-72 h-72 sm:w-96 sm:h-96 shadow-around">
                        <div className="flex items-center justify-between">
                            <h1 className="capitalize font-bold text-xl">{ t('notifications')}</h1>
                            {/* <div className="text-blue-normal first-letter:capitalize font-semibold text-sm">{ t('mark all as read')}</div> */}
                        </div>
                        <div className="flex flex-col justify-center items-center h-full font-semibold text-lg">
                            { t('no notification available')}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Notification;